import React from 'react';

const SvgUserTag: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs>
        <clipPath id="userTag_svg__a">
          <path d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
      <g
        clipPath="url(#userTag_svg__a)"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 5h4a2 2 0 012 2v13a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h4" />
        <circle cx={2.25} cy={2.25} r={2.25} transform="translate(9.75 10)" />
        <path d="M15.6 19a3.176 3.176 0 00-2.949-2h-1.297a3.173 3.173 0 00-2.948 2" />
        <rect width={4} height={5} rx={1} transform="translate(10 2)" />
      </g>
    </svg>
  );
};

export default SvgUserTag;
